export default __webpack_public_path__ + "static/media/dhl_aviation.0dbbc0e8.png";